<div class="backdrop" (click)='onClose()'></div>
<div class="alert-box">
  <h1>{{ message }}</h1>
  <div class="alert-box-actions">
    <button class="bttn-simple bttn-md bttn-danger" (click)='onClose()'>Close</button>
  </div>
</div>
